import DOMPurify from "dompurify";
import { trustedTypes } from "trusted-types";
import trustedSources from "../../infra/resources/trusted_script_sources.json";

const trusted = new Set(trustedSources);

if (!window.trustedTypes || !window.trustedTypes.createPolicy) {
  window.trustedTypes = trustedTypes;
}

DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  if ("target" in node) {
    node.setAttribute("rel", "noopener");
    node.setAttribute("target", "_blank");
  }
});

function sanitizeHTML(html) {
  const sanitized = DOMPurify.sanitize(html, {
    ADD_ATTR: ["target"],
    RETURN_TRUSTED_TYPE: true,
  });

  return sanitized;
}

function sanitizeScript(script) {
  // We should never allow inline scripts
  return null;
}

function sanitizeScriptURL(url) {
  try {
    if (url[0] === "/") {
      return url;
    }

    const { origin } = new URL(url);
    const valid = trusted.has(origin) || origin.endsWith(".vistaly.com");
    if (!valid) {
      throw new Error("Invalid url " + url);
    }
    return url;
  } catch (e) {
    console.error(e);
    return null;
  }
}

window.trustedTypes.createPolicy("default", {
  createHTML: sanitizeHTML,
  createScript: sanitizeScript,
  createScriptURL: sanitizeScriptURL,
});
